

// import React, { useState, useEffect } from "react";
// import { useSelector, useDispatch } from 'react-redux';
// import { selectUser, addProperty, incrementPropertyCount } from '../Commonlibs/userSlice';
// import { useNavigate, useLocation } from 'react-router-dom';
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   InputAdornment,
//   Dialog,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   DialogTitle,
//   Select,
//   MenuItem,
//   FormControl,
// } from "@mui/material";
// import { Check as CheckIcon, Login as LoginIcon } from "@mui/icons-material";
// import Loader from '../Loader/Loader';
// import PostAccess from './PostAccess';

// const PriceDetails = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const user = useSelector(selectUser);
//   const dispatch = useDispatch();

//   // State variables
//   const [askingPrice, setAskingPrice] = useState(() => localStorage.getItem('price_askingPrice') || '');
//   const [askingPriceError, setAskingPriceError] = useState('');
//   const [currency, setCurrency] = useState(() => localStorage.getItem('price_currency') || '₹');
//   const [constructionStatus, setConstructionStatus] = useState(() => localStorage.getItem('price_constructionStatus') || 'ready to move');
//   const [negotiable, setNegotiable] = useState(() => localStorage.getItem('price_negotiable') === 'false' ? false : true);
//   const [loading, setLoading] = useState(false);
//   const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });
  
//   const [loginDialog, setLoginDialog] = useState({ open: false });

//   const { propertyType, category, ...otherProps } = location.state || {};

//   // Clear form data
//   const clearAllFormData = () => {
//     setAskingPrice('');
//     setCurrency('INR');
//     setConstructionStatus('ready to move');
//     setNegotiable(true);
//     localStorage.removeItem('price_askingPrice');
//     localStorage.removeItem('price_currency');
//     localStorage.removeItem('price_constructionStatus');
//     localStorage.removeItem('price_negotiable');
//     localStorage.removeItem('propertyDetailsFormState');
//     localStorage.removeItem('propertyType');
//     localStorage.removeItem('category');
//     localStorage.removeItem('propertyLocation');
//     localStorage.removeItem('amenities_society');
//     localStorage.removeItem('amenities_furnishing');
//     localStorage.removeItem('amenities_other');
//     localStorage.removeItem('propertyImagePreviews');
//     setAskingPriceError('');
//   };

//   const formatIndianNumber = (num) => {
//     if (!num) return '';
//     const numStr = num.toString();
//     const lastThree = numStr.substring(numStr.length - 3);
//     const otherNumbers = numStr.substring(0, numStr.length - 3);
//     if (otherNumbers !== '') {
//       return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
//     }
//     return lastThree;
//   };

//   const convertToWords = (num) => {
//     if (!num || num === '0') return '';
//     const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
//     const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
//     const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

//     const numToWords = (n) => {
//       if (n < 10) return ones[n];
//       if (n < 20) return teens[n - 10];
//       if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + ones[n % 10] : '');
//       return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + numToWords(n % 100) : '');
//     };

//     const crore = Math.floor(num / 10000000);
//     const lakh = Math.floor((num % 10000000) / 100000);
//     const thousand = Math.floor((num % 100000) / 1000);
//     const hundred = num % 1000;

//     let result = '';
//     if (crore > 0) result += numToWords(crore) + ' Crore ';
//     if (lakh > 0) result += numToWords(lakh) + ' Lakh ';
//     if (thousand > 0) result += numToWords(thousand) + ' Thousand ';
//     if (hundred > 0) result += numToWords(hundred);

//     return result.trim();
//   };

//   const handleBack = () => {
//     const assetType = location.state?.asset_type || '';
//     const selectedType = location.state?.selectedType || '';
//     const isPlot = assetType === 'plot' || selectedType === 'plot';
//     const isAgricultureLand = assetType?.toLowerCase() === 'agriculture land' || selectedType === 'agriculture-land';
//     const isCommercial = propertyType === 'Commercial';
//     const isFarmhouse = assetType?.toLowerCase() === 'farm house' || selectedType === 'farm-house';

//     const shouldShowAmenities = (!isCommercial || isFarmhouse) && !isPlot && !isAgricultureLand;

//     if (shouldShowAmenities) {
//       navigate('/amenities', {
//         state: {
//           propertyType: propertyType || location.state?.propertyType,
//           category: category || location.state?.category,
//           location: location.state?.location || '',
//           asset_type: location.state?.asset_type || '',
//           selectedType: location.state?.selectedType || '',
//           ...location.state
//         }
//       });
//     } else {
//       navigate('/property-details', {
//         state: {
//           propertyType: propertyType || location.state?.propertyType,
//           category: category || location.state?.category,
//           location: location.state?.location || '',
//           asset_type: location.state?.asset_type || '',
//           selectedType: location.state?.selectedType || '',
//           ...location.state
//         }
//       });
//     }
//   };

//   useEffect(() => {
//     localStorage.setItem('price_askingPrice', askingPrice);
//     localStorage.setItem('price_currency', currency);
//     localStorage.setItem('price_constructionStatus', constructionStatus);
//     localStorage.setItem('price_negotiable', negotiable.toString());
//   }, [askingPrice, currency, constructionStatus, negotiable]);

//   const validateAskingPrice = (value) => {
//     if (!value || value.trim() === '') {
//       setAskingPriceError('Property cost is required');
//       return false;
//     }
//     const priceRegex = /^[1-9]\d*$/;
//     if (!priceRegex.test(value)) {
//       setAskingPriceError('Please enter a valid whole number amount (e.g., 5000000)');
//       return false;
//     }
//     const amount = parseInt(value, 10);
//     if (amount < 100000) {
//       setAskingPriceError('Property cost must be at least 1 lakh');
//       return false;
//     }
//     if (amount > 10000000000) {
//       setAskingPriceError('Property cost cannot exceed 1000 crores');
//       return false;
//     }
//     setAskingPriceError('');
//     return true;
//   };

//   const handleAskingPriceChange = (e) => {
//     const value = e.target.value;
//     if (value === '' || /^[0-9]*$/.test(value)) {
//       setAskingPrice(value);
//       validateAskingPrice(value);
//     }
//   };

//   const handleUploadProperty = async () => {
//     const isPriceValid = validateAskingPrice(askingPrice);

//     if (!isPriceValid) {
//       setAlert({
//         open: true,
//         message: 'Please fix the errors before submitting',
//         severity: 'error'
//       });
//       return;
//     }

//     const userId = user?.id;
//     if (!userId) {
//       setLoginDialog({ open: true });
//       return;
//     }

//     await performPropertyUpload();
//   };

//   const handleLoginRedirect = () => {
//     setLoginDialog({ open: false });
//     navigate('/login', { 
//       state: { 
//         returnTo: location.pathname,
//         preserveData: true,
//         ...location.state
//       } 
//     });
//   };

//   const performPropertyUpload = async () => {
//     setLoading(true);

//     try {
//       if (!askingPrice || !currency || !constructionStatus) {
//         setAlert({
//           open: true,
//           message: 'Please fill all required fields',
//           severity: 'error'
//         });
//         setLoading(false);
//         return;
//       }

//       const userId = user?.id;
//       if (!userId) {
//         setLoading(false);
//         return;
//       }

//       const assetType = location.state?.asset_type || '';
//       const selectedType = location.state?.selectedType || '';
//       const assetTypeLower = assetType.toLowerCase();
//       const selectedTypeLower = selectedType.toLowerCase();
      
//       const isPlot = assetTypeLower === 'plot' || selectedTypeLower === 'plot';
//       const isAgricultureLand = assetTypeLower === 'agriculture land' || selectedTypeLower === 'agriculture-land';
//       const isCommercial = propertyType === 'Commercial';
//       const isFarmhouse = assetTypeLower === 'farm house' || assetTypeLower === 'farmhouse' || selectedTypeLower === 'farm-house';
//       const isApartment = assetTypeLower === 'apartment' || selectedTypeLower === 'apartment';
//       const isIndependentHouse = assetTypeLower === 'independent house' || selectedTypeLower === 'independent-house';
//       const isPentHouse = assetTypeLower === 'pent house' || assetTypeLower === 'penthouse' || selectedTypeLower === 'pent-house';
//       const isStudio = assetTypeLower === 'studio' || selectedTypeLower === 'studio';
//       const isVilla = assetTypeLower === 'villa' || selectedTypeLower === 'villa';
//       const isOffice = assetTypeLower === 'office' || selectedTypeLower === 'office';
//       const isShowroom = assetTypeLower === 'showroom' || selectedTypeLower === 'showroom';
//       const isRetailShop = assetTypeLower === 'retail shop' || selectedTypeLower === 'retail-shop';
//       const isWarehouse = assetTypeLower === 'warehouse' || assetTypeLower === 'ware house' || selectedTypeLower === 'warehouse';

//       const formData = new FormData();
      
//       // Basic required fields
//       formData.append('seller_id', userId.toString());
//       formData.append('property_type', isCommercial ? 'commercial' : 'residential');
//       formData.append('category', 'sale');
//       formData.append('location', location.state?.location || '');
//       formData.append('asset_type', assetType || '');
//       formData.append('property_name', location.state?.buildingName || location.state?.property_name || '');
//       formData.append('area_name', location.state?.areaName || location.state?.area_name || '');
//       formData.append('full_address', location.state?.completeAddress || location.state?.full_address || '');

//       // Price and construction details
//       formData.append('asking_price', askingPrice);
//       formData.append('negotiable', negotiable.toString());
//       formData.append('currency', currency);
//       formData.append('construction_status', constructionStatus);

//       // Rental fields - empty for sale
//       formData.append('monthly_rent', '');
//       formData.append('available_from', '');
//       formData.append('security_deposit', '');

//       // ✅ APARTMENT - carpet_area, built_up_area (mandatory), uds (optional)
//       if (isApartment) {
//         formData.append('carpet_area', location.state?.carpet_area || '');
//         formData.append('carpet_area_units', location.state?.carpet_area ? (location.state?.carpet_area_units || location.state?.carpetAreaUnits || '') : '');
//         formData.append('built_up_area', location.state?.built_up_area || location.state?.builtUpArea || '');
//         formData.append('built_up_area_units', (location.state?.built_up_area || location.state?.builtUpArea) ? (location.state?.built_up_area_units || location.state?.builtUpAreaUnits || '') : '');
//         formData.append('uds', location.state?.uds || '');
//         formData.append('uds_units', location.state?.uds ? (location.state?.uds_units || location.state?.udsUnits || '') : '');
//         formData.append('property_size', '');
//         formData.append('property_size_units', '');
//         formData.append('zone_type', '');
//         formData.append('length', '');
//         formData.append('width', '');
//         formData.append('length_units', '');
//         formData.append('width_units', '');
//       } 
//       // ✅ INDEPENDENT HOUSE - built_up_area, property_size (mandatory), uds (optional)
//       else if (isIndependentHouse) {
//         formData.append('built_up_area', location.state?.built_up_area || location.state?.builtUpArea || '');
//         formData.append('built_up_area_units', (location.state?.built_up_area || location.state?.builtUpArea) ? (location.state?.built_up_area_units || location.state?.builtUpAreaUnits || '') : '');
//         formData.append('property_size', location.state?.propertySize || location.state?.property_size || '');
//         formData.append('property_size_units', (location.state?.propertySize || location.state?.property_size) ? (location.state?.property_size_units || location.state?.selectedUnit || '') : '');
//         formData.append('uds', location.state?.uds || '');
//         formData.append('uds_units', location.state?.uds ? (location.state?.uds_units || location.state?.udsUnits || '') : '');
//         formData.append('carpet_area', '');
//         formData.append('carpet_area_units', '');
//         formData.append('zone_type', '');
//         formData.append('length', '');
//         formData.append('width', '');
//         formData.append('length_units', '');
//         formData.append('width_units', '');
//       } 
//       // ✅ PENT HOUSE - built_up_area (mandatory), NO property_size, NO carpet_area, NO uds
//       else if (isPentHouse) {
//         formData.append('built_up_area', location.state?.built_up_area || location.state?.builtUpArea || '');
//         formData.append('built_up_area_units', (location.state?.built_up_area || location.state?.builtUpArea) ? (location.state?.built_up_area_units || location.state?.builtUpAreaUnits || '') : '');
//         formData.append('property_size', '');
//         formData.append('property_size_units', '');
//         formData.append('carpet_area', '');
//         formData.append('carpet_area_units', '');
//         formData.append('uds', '');
//         formData.append('uds_units', '');
//         formData.append('zone_type', '');
//         formData.append('length', '');
//         formData.append('width', '');
//         formData.append('length_units', '');
//         formData.append('width_units', '');
//       } 
//       // ✅ STUDIO - property_size (mandatory), built_up_area (optional)
//       else if (isStudio) {
//         formData.append('property_size', location.state?.propertySize || location.state?.property_size || '');
//         formData.append('property_size_units', (location.state?.propertySize || location.state?.property_size) ? (location.state?.property_size_units || location.state?.selectedUnit || '') : '');
//         formData.append('built_up_area', location.state?.built_up_area || location.state?.builtUpArea || '');
//         formData.append('built_up_area_units', (location.state?.built_up_area || location.state?.builtUpArea) ? (location.state?.built_up_area_units || location.state?.builtUpAreaUnits || '') : '');
//         formData.append('carpet_area', '');
//         formData.append('carpet_area_units', '');
//         formData.append('uds', '');
//         formData.append('uds_units', '');
//         formData.append('zone_type', '');
//         formData.append('length', '');
//         formData.append('width', '');
//         formData.append('length_units', '');
//         formData.append('width_units', '');
//       } 
//       // ✅ VILLA - built_up_area, property_size (mandatory)
//       else if (isVilla) {
//         formData.append('built_up_area', location.state?.built_up_area || location.state?.builtUpArea || '');
//         formData.append('built_up_area_units', (location.state?.built_up_area || location.state?.builtUpArea) ? (location.state?.built_up_area_units || location.state?.builtUpAreaUnits || '') : '');
//         formData.append('property_size', location.state?.propertySize || location.state?.property_size || '');
//         formData.append('property_size_units', (location.state?.propertySize || location.state?.property_size) ? (location.state?.property_size_units || location.state?.selectedUnit || '') : '');
//         formData.append('carpet_area', '');
//         formData.append('carpet_area_units', '');
//         formData.append('uds', '');
//         formData.append('uds_units', '');
//         formData.append('zone_type', '');
//         formData.append('length', '');
//         formData.append('width', '');
//         formData.append('length_units', '');
//         formData.append('width_units', '');
//       } 
//       // ✅ PLOT & AGRICULTURE LAND - property_size, zone_type, ownership
//       else if (isPlot || isAgricultureLand) {
//         formData.append('property_size', location.state?.propertySize || location.state?.property_size || '');
//         formData.append('property_size_units', (location.state?.propertySize || location.state?.property_size) ? (location.state?.property_size_units || location.state?.selectedUnit || '') : '');
//         formData.append('zone_type', location.state?.zone_type || location.state?.zoneType || '');
//         formData.append('ownership', location.state?.ownership || location.state?.selectedOwnership || '');
//         formData.append('carpet_area', '');
//         formData.append('carpet_area_units', '');
//         formData.append('built_up_area', '');
//         formData.append('built_up_area_units', '');
//         formData.append('uds', '');
//         formData.append('uds_units', '');
        
//         // For agriculture land, don't send length/width
//         if (isAgricultureLand) {
//           formData.append('length', '');
//           formData.append('width', '');
//           formData.append('length_units', '');
//           formData.append('width_units', '');
//         } else {
//           formData.append('length', location.state?.length || location.state?.propertyLength || '');
//           formData.append('width', location.state?.width || location.state?.propertyWidth || '');
//           formData.append('length_units', (location.state?.length || location.state?.propertyLength) ? (location.state?.length_units || location.state?.lengthUnit || '') : '');
//           formData.append('width_units', (location.state?.width || location.state?.propertyWidth) ? (location.state?.width_units || location.state?.widthUnit || '') : '');
//         }
//       } 
//       // ✅ FARMHOUSE - built_up_area, property_size (mandatory)
//       else if (isFarmhouse) {
//         formData.append('built_up_area', location.state?.built_up_area || location.state?.builtUpArea || '');
//         formData.append('built_up_area_units', (location.state?.built_up_area || location.state?.builtUpArea) ? (location.state?.built_up_area_units || location.state?.builtUpAreaUnits || '') : '');
//         formData.append('property_size', location.state?.propertySize || location.state?.property_size || '');
//         formData.append('property_size_units', (location.state?.propertySize || location.state?.property_size) ? (location.state?.property_size_units || location.state?.selectedUnit || '') : '');
//         formData.append('length', location.state?.length || location.state?.propertyLength || '');
//         formData.append('width', location.state?.width || location.state?.propertyWidth || '');
//         formData.append('length_units', (location.state?.length || location.state?.propertyLength) ? (location.state?.length_units || location.state?.lengthUnit || '') : '');
//         formData.append('width_units', (location.state?.width || location.state?.propertyWidth) ? (location.state?.width_units || location.state?.widthUnit || '') : '');
//         formData.append('carpet_area', '');
//         formData.append('carpet_area_units', '');
//         formData.append('uds', '');
//         formData.append('uds_units', '');
//         formData.append('zone_type', '');
//       } 
//       // ✅ COMMERCIAL OFFICE - property_size, built_up_area (optional), zone_type (optional)
//       else if (isCommercial && isOffice) {
//         formData.append('property_size', location.state?.propertySize || location.state?.property_size || '');
//         formData.append('property_size_units', (location.state?.propertySize || location.state?.property_size) ? (location.state?.property_size_units || location.state?.selectedUnit || '') : '');
//         formData.append('built_up_area', location.state?.built_up_area || location.state?.builtUpArea || '');
//         formData.append('built_up_area_units', (location.state?.built_up_area || location.state?.builtUpArea) ? (location.state?.built_up_area_units || location.state?.builtUpAreaUnits || '') : '');
//         formData.append('zone_type', location.state?.zone_type || location.state?.zoneType || '');
//         formData.append('carpet_area', '');
//         formData.append('carpet_area_units', '');
//         formData.append('uds', '');
//         formData.append('uds_units', '');
//         formData.append('length', '');
//         formData.append('width', '');
//         formData.append('length_units', '');
//         formData.append('width_units', '');
//       } 
//       // ✅ COMMERCIAL SHOWROOM & RETAIL SHOP - property_size, built_up_area, carpet_area (optional)
//       else if (isCommercial && (isShowroom || isRetailShop)) {
//         formData.append('property_size', location.state?.propertySize || location.state?.property_size || '');
//         formData.append('property_size_units', (location.state?.propertySize || location.state?.property_size) ? (location.state?.property_size_units || location.state?.selectedUnit || '') : '');
//         formData.append('built_up_area', location.state?.built_up_area || location.state?.builtUpArea || '');
//         formData.append('built_up_area_units', (location.state?.built_up_area || location.state?.builtUpArea) ? (location.state?.built_up_area_units || location.state?.builtUpAreaUnits || '') : '');
//         formData.append('carpet_area', location.state?.carpet_area || '');
//         formData.append('carpet_area_units', location.state?.carpet_area ? (location.state?.carpet_area_units || location.state?.carpetAreaUnits || '') : '');
//         formData.append('zone_type', '');
//         formData.append('uds', '');
//         formData.append('uds_units', '');
//         formData.append('length', '');
//         formData.append('width', '');
//         formData.append('length_units', '');
//         formData.append('width_units', '');
//       } 
//       // ✅ COMMERCIAL WAREHOUSE - property_size, zone_type, built_up_area, carpet_area (optional)
//       else if (isCommercial && isWarehouse) {
//         formData.append('property_size', location.state?.propertySize || location.state?.property_size || '');
//         formData.append('property_size_units', (location.state?.propertySize || location.state?.property_size) ? (location.state?.property_size_units || location.state?.selectedUnit || '') : '');
//         formData.append('zone_type', location.state?.zone_type || location.state?.zoneType || '');
//         formData.append('built_up_area', location.state?.built_up_area || location.state?.builtUpArea || '');
//         formData.append('built_up_area_units', (location.state?.built_up_area || location.state?.builtUpArea) ? (location.state?.built_up_area_units || location.state?.builtUpAreaUnits || '') : '');
//         formData.append('carpet_area', location.state?.carpet_area || '');
//         formData.append('carpet_area_units', location.state?.carpet_area ? (location.state?.carpet_area_units || location.state?.carpetAreaUnits || '') : '');
//         formData.append('uds', '');
//         formData.append('uds_units', '');
//         formData.append('length', '');
//         formData.append('width', '');
//         formData.append('length_units', '');
//         formData.append('width_units', '');
//       } 
//             // ✅ COMMERCIAL PLOT - property_size, zone_type (optional)
//       else if (isCommercial && isPlot) {
//         formData.append('property_size', location.state?.propertySize || location.state?.property_size || '');
//         formData.append('property_size_units', (location.state?.propertySize || location.state?.property_size) ? (location.state?.property_size_units || location.state?.selectedUnit || '') : '');
//         formData.append('zone_type', location.state?.zone_type || location.state?.zoneType || '');
//         formData.append('ownership', location.state?.ownership || location.state?.selectedOwnership || '');
//         formData.append('length', location.state?.length || location.state?.propertyLength || '');
//         formData.append('width', location.state?.width || location.state?.propertyWidth || '');
//         formData.append('length_units', (location.state?.length || location.state?.propertyLength) ? (location.state?.length_units || location.state?.lengthUnit || '') : '');
//         formData.append('width_units', (location.state?.width || location.state?.propertyWidth) ? (location.state?.width_units || location.state?.widthUnit || '') : '');
//         formData.append('built_up_area', '');
//         formData.append('built_up_area_units', '');
//         formData.append('carpet_area', '');
//         formData.append('carpet_area_units', '');
//         formData.append('uds', '');
//         formData.append('uds_units', '');
//       }
//       // ✅ Default fallback
//       else {
//         formData.append('property_size', location.state?.propertySize || location.state?.property_size || '');
//         formData.append('property_size_units', (location.state?.propertySize || location.state?.property_size) ? (location.state?.property_size_units || location.state?.selectedUnit || '') : '');
//         formData.append('built_up_area', location.state?.built_up_area || location.state?.builtUpArea || '');
//         formData.append('built_up_area_units', (location.state?.built_up_area || location.state?.builtUpArea) ? (location.state?.built_up_area_units || location.state?.builtUpAreaUnits || '') : '');
//         formData.append('carpet_area', location.state?.carpet_area || '');
//         formData.append('carpet_area_units', location.state?.carpet_area ? (location.state?.carpet_area_units || location.state?.carpetAreaUnits || '') : '');
//         formData.append('zone_type', location.state?.zone_type || location.state?.zoneType || '');
//         formData.append('uds', location.state?.uds || '');
//         formData.append('uds_units', location.state?.uds ? (location.state?.uds_units || location.state?.udsUnits || '') : '');
//         formData.append('length', location.state?.length || location.state?.propertyLength || '');
//         formData.append('width', location.state?.width || location.state?.propertyWidth || '');
//         formData.append('length_units', (location.state?.length || location.state?.propertyLength) ? (location.state?.length_units || location.state?.lengthUnit || '') : '');
//         formData.append('width_units', (location.state?.width || location.state?.propertyWidth) ? (location.state?.width_units || location.state?.widthUnit || '') : '');
//       }

//       // YouTube link
//       const youtubeLink = location.state?.socialMediaLink?.trim() || location.state?.youtube_link?.trim() || '';
//       formData.append('youtube_link', youtubeLink);

//       // Description, content, landmark
//       formData.append('description', location.state?.propertyDescription || location.state?.description || '');
//       formData.append('content', location.state?.content || '');
//       formData.append('landmark', location.state?.landmark || '');

//       // Age of property - NO HARDCODED VALUE
//       formData.append('age_of_property', location.state?.age_of_property || location.state?.propertyAge || '');

//       // BHK, furnishing, floors based on property type
//       if (isPlot || isAgricultureLand) {
//         formData.append('locality', '');
//         formData.append('bhk', '');
//         formData.append('furnish_type', '');
//         formData.append('total_floors', '');
//         formData.append('select_floor', '');
//         formData.append('society_aminities', '');
//         formData.append('furnish_facilities', '');
//         formData.append('other_facilities', '');
//         formData.append('facilities_distance', '');
//       } else {
//         formData.append('locality', location.state?.locality || '');
        
//         if (!isCommercial) {
//           formData.append('bhk', location.state?.bhk || location.state?.selectedBHK || '');
//           formData.append('furnish_type', location.state?.furnish_type || location.state?.selectedFurnish || '');
//         } else {
//           formData.append('bhk', '');
//           formData.append('furnish_type', '');
//         }

//         formData.append('total_floors', location.state?.totalFloors || location.state?.total_floors || '');
//         formData.append('select_floor', location.state?.selectedFloor || location.state?.select_floor || '');

//         // Amenities - NO HARDCODED VALUES
//         if (!isCommercial || isFarmhouse) {
//           formData.append('society_aminities', location.state?.society_aminities || '');
//           formData.append('furnish_facilities', location.state?.furnish_facilities || '');
//           formData.append('other_facilities', location.state?.other_facilities || '');
//           formData.append('facilities_distance', location.state?.facilities_distance || '');
//         } else {
//           formData.append('society_aminities', '');
//           formData.append('furnish_facilities', '');
//           formData.append('other_facilities', '');
//           formData.append('facilities_distance', '');
//         }
//       }

//       // Commercial specific fields - NO HARDCODED VALUES FOR HUB & OWNERSHIP
//       if (isCommercial) {
//         formData.append('commercial_catgory', 'sale');
//         formData.append('commercial_asset_type', assetType);
//         formData.append('hub', location.state?.hub || location.state?.selectedHub || '');
//         formData.append('ownership', location.state?.ownership || location.state?.selectedOwnership || '');
//       } else {
//         formData.append('commercial_catgory', '');
//         formData.append('commercial_asset_type', '');
//         formData.append('hub', '');
//         if (!isPlot && !isAgricultureLand) {
//           formData.append('ownership', '');
//         }
//       }

//       // Images
//       if (location.state?.propertyImages && location.state.propertyImages.length > 0) {
//         location.state.propertyImages.forEach((file) => {
//           formData.append('property_images', file);
//         });
//       }

//       // Videos
//       if (location.state?.propertyVideos && location.state.propertyVideos.length > 0) {
//         location.state.propertyVideos.forEach((file) => {
//           formData.append('property_videos', file);
//         });
//       }

//       console.log('📤 FormData being sent:', {
//         asset_type: assetType,
//         carpet_area: formData.get('carpet_area'),
//         built_up_area: formData.get('built_up_area'),
//         uds: formData.get('uds'),
//         property_size: formData.get('property_size'),
//         zone_type: formData.get('zone_type'),
//         length: formData.get('length'),
//         width: formData.get('width'),
//         hub: formData.get('hub'),
//         ownership: formData.get('ownership')
//       });

//       const response = await fetch('https://propertydealstalk.com/api/property/addProperty', {
//         method: 'POST',
//         body: formData
//       });

//       const data = await response.json();

//       if (data.status === 'SUCCESS') {
//         clearAllFormData();

//         if (data.result && data.result.id) {
//           dispatch(addProperty(data.result.id));
//           dispatch(incrementPropertyCount());
//         }

//         setAlert({
//           open: true,
//           message: 'Property added successfully!',
//           severity: 'success'
//         });

//         setTimeout(() => {
//           navigate('/sell-properties');
//         }, 2000);
//       } else {
//         throw new Error(data.message || 'Failed to add property');
//       }
//     } catch (error) {
//       console.error('Error adding property:', error);
//       setAlert({
//         open: true,
//         message: error.message || 'Failed to add property. Please try again.',
//         severity: 'error'
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (alert.open) {
//       const timer = setTimeout(() => {
//         setAlert({ ...alert, open: false });
//       }, 9000);
//       return () => clearTimeout(timer);
//     }
//   }, [alert.open]);

//   return (
//     <PostAccess
//       currentStep={3}
//       category={category}
//       propertyType={propertyType}
//       assetType={location.state?.asset_type || ''}
//     >
//       {loading && <Loader />}

//       <Box
//         sx={{
//           flex: 1,
//           maxWidth: { xs: '100%', md: '800px' },
//           p: { xs: 2.5, sm: 3, md: 3.5 },
//           backgroundColor: '#ffffff',
//           borderRadius: 2,
//           border: '1px solid #e0e0e0',
//         }}
//       >
//         <Typography
//           variant="h5"
//           sx={{
//             fontFamily: 'Outfit',
//             fontWeight: 600,
//             mb: 0.5,
//             fontSize: { xs: '18px', md: '22px' },
//           }}
//         >
//           Add Price Details
//         </Typography>

//         <Typography
//           sx={{
//             fontFamily: 'Outfit',
//             fontSize: '13px',
//             color: '#666',
//             mb: 3,
//           }}
//         >
//           Complete all required fields
//         </Typography>

//         <Box sx={{ mt: 4 }}>
//           <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 4 }}>
//             {/* Property Cost */}
//             <Box sx={{ width: '215px' }}>
//               <Typography
//                 component="label"
//                 sx={{
//                   fontFamily: "Outfit, sans-serif",
//                   fontWeight: 500,
//                   color: "text.secondary",
//                   fontSize: "16px",
//                   display: "block",
//                   mb: 1.5,
//                 }}
//               >
//                 Property Cost <Box component="span" sx={{ color: "#ff0000" }}>*</Box>
//               </Typography>
//               <TextField
//                 placeholder="Enter amount"
//                 value={formatIndianNumber(askingPrice)}
//                 onChange={(e) => {
//                   const value = e.target.value.replace(/,/g, '');
//                   if (value === '' || /^[0-9]*$/.test(value)) {
//                     setAskingPrice(value);
//                     validateAskingPrice(value);
//                   }
//                 }}
//                 error={!!askingPriceError}
//                 helperText={askingPriceError}
//                 InputProps={{
//                   endAdornment: <InputAdornment position="end">₹</InputAdornment>,
//                 }}
//                 sx={{
//                   width: "100%",
//                   "& .MuiInputBase-root": {
//                     height: "50px",
//                     bgcolor: "background.paper",
//                     borderRadius: "10px",
//                     fontFamily: "Outfit, sans-serif",
//                     fontSize: "15px",
//                   },
//                 }}
//               />
//               {askingPrice && !askingPriceError && (
//                 <Typography
//                   sx={{
//                     fontFamily: "Outfit, sans-serif",
//                     fontSize: "12px",
//                     color: "#4f26ff",
//                     mt: 0.5,
//                     fontStyle: "italic",
//                   }}
//                 >
//                   {convertToWords(parseInt(askingPrice))}
//                 </Typography>
//               )}
//             </Box>

//             {/* Construction Status */}
//             <Box sx={{ width: '215px' }}>
//               <Typography
//                 component="label"
//                 sx={{
//                   fontFamily: "Outfit, sans-serif",
//                   fontWeight: 500,
//                   color: "text.secondary",
//                   fontSize: "16px",
//                   display: "block",
//                   mb: 1.5,
//                 }}
//               >
//                 Construction Status <Box component="span" sx={{ color: "#ff0004" }}>*</Box>
//               </Typography>
//               <FormControl fullWidth>
//                 <Select
//                   value={constructionStatus}
//                   onChange={(e) => setConstructionStatus(e.target.value)}
//                   sx={{
//                     height: "50px",
//                     borderRadius: "10px",
//                     fontFamily: "Outfit, sans-serif",
//                     fontSize: "15px",
//                     bgcolor: "white",
//                   }}
//                 >
//                   <MenuItem value="ready to move" sx={{ fontFamily: "Outfit, sans-serif" }}>
//                     Ready to Move
//                   </MenuItem>
//                   <MenuItem value="under construction" sx={{ fontFamily: "Outfit, sans-serif" }}>
//                     Under Construction
//                   </MenuItem>
//                 </Select>
//               </FormControl>
//             </Box>

//             {/* Price Negotiable */}
//             <Box sx={{ width: '215px' }}>
//               <Typography
//                 component="label"
//                 sx={{
//                   fontFamily: "Outfit, sans-serif",
//                   fontWeight: 500,
//                   color: "text.secondary",
//                   fontSize: "16px",
//                   display: "block",
//                   mb: 1.5,
//                 }}
//               >
//                 Price Negotiable? <Box component="span" sx={{ color: "#ff0004" }}>*</Box>
//               </Typography>
//               <FormControl fullWidth>
//                 <Select
//                   value={negotiable}
//                   onChange={(e) => setNegotiable(e.target.value)}
//                   sx={{
//                     height: "50px",
//                     borderRadius: "10px",
//                     fontFamily: "Outfit, sans-serif",
//                     fontSize: "15px",
//                     bgcolor: "white",
//                   }}
//                 >
//                   <MenuItem value={true} sx={{ fontFamily: "Outfit, sans-serif" }}>
//                     Yes
//                   </MenuItem>
//                   <MenuItem value={false} sx={{ fontFamily: "Outfit, sans-serif" }}>
//                     No
//                   </MenuItem>
//                 </Select>
//               </FormControl>
//             </Box>
//           </Box>
//         </Box>

//         {/* Action Buttons */}
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             mt: 6,
//             gap: 2,
//           }}
//         >
//           <Button
//             variant="outlined"
//             onClick={handleBack}
//             sx={{
//               px: 3,
//               py: 1.2,
//               borderRadius: 1.5,
//               textTransform: "none",
//               fontFamily: "Outfit",
//               fontSize: "14px",
//               color: "#666",
//               borderColor: "#e0e0e0",
//               minWidth: "100px",
//             }}
//           >
//             Back
//           </Button>

//           <Button
//             onClick={handleUploadProperty}
//             disabled={loading || !!askingPriceError}
//             sx={{
//               px: 3,
//               py: 1.2,
//               borderRadius: 1.5,
//               textTransform: "none",
//               fontFamily: "Outfit",
//               fontSize: "14px",
//               backgroundColor: "#1976d2",
//               color: "white",
//               minWidth: "150px",
//               '&:hover': {
//                 backgroundColor: "#1565c0",
//               },
//               '&:disabled': {
//                 bgcolor: '#b0b0b0',
//                 color: '#f5f5f5'
//               }
//             }}
//           >
//             {loading ? "Uploading..." : "Post Property "}
//           </Button>
//         </Box>
//       </Box>

//       {/* Login Required Dialog */}
//       <Dialog
//         open={loginDialog.open}
//         onClose={() => setLoginDialog({ open: false })}
//         PaperProps={{
//           sx: {
//             borderRadius: "16px",
//             boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.12)',
//             maxWidth: "420px",
//             width: "100%",
//             margin: '0 16px',
//             overflow: 'hidden'
//           }
//         }}
//       >
//         <DialogTitle sx={{
//           textAlign: 'center',
//           pt: 4,
//           pb: 2,
//           fontFamily: 'Outfit',
//           fontSize: '22px',
//           fontWeight: 600,
//           color: '#333'
//         }}>
//           Login Required
//         </DialogTitle>
//         <DialogContent sx={{
//           padding: "0 32px 24px",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//         }}>
//           <Box sx={{
//             width: 64,
//             height: 64,
//             borderRadius: '50%',
//             backgroundColor: 'rgba(25, 118, 210, 0.1)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             mb: 2
//           }}>
//             <LoginIcon sx={{ fontSize: 32, color: '#1976d2' }} />
//           </Box>
//           <DialogContentText sx={{
//             fontFamily: "Outfit",
//             fontSize: "16px",
//             textAlign: "center",
//             color: '#666',
//             margin: 0,
//             lineHeight: 1.6
//           }}>
//             Please login to continue posting your property. Your progress will be saved.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions sx={{
//           padding: '0 32px 32px',
//           flexDirection: 'column',
//           gap: 1.5
//         }}>
//           <Button
//             onClick={handleLoginRedirect}
//             variant="contained"
//             fullWidth
//             sx={{
//               py: 1.5,
//               borderRadius: 2,
//               textTransform: "none",
//               fontFamily: "Outfit",
//               fontSize: "15px",
//               fontWeight: 600,
//               backgroundColor: "#1976d2",
//               boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
//               '&:hover': {
//                 backgroundColor: "#1565c0",
//                 boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)',
//               }
//             }}
//           >
//             Login Now
//           </Button>
//           <Button
//             onClick={() => setLoginDialog({ open: false })}
//             variant="text"
//             fullWidth
//             sx={{
//               py: 1.2,
//               borderRadius: 2,
//               textTransform: "none",
//               fontFamily: "Outfit",
//               fontSize: "14px",
//               color: "#666",
//               '&:hover': {
//                 backgroundColor: 'rgba(0, 0, 0, 0.04)'
//               }
//             }}
//           >
//             Cancel
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Alert Dialog */}
//       <Dialog
//         open={alert.open}
//         onClose={() => setAlert({ ...alert, open: false })}
//         PaperProps={{
//           sx: {
//             borderRadius: "12px",
//             boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
//             maxWidth: "400px",
//             width: "100%",
//             margin: '0 16px',
//             overflow: 'hidden'
//           }
//         }}
//       >
//         <DialogContent sx={{
//           padding: "24px",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           backgroundColor: "#ffffff",
//           minHeight: "180px",
//         }}>
//           <Box sx={{ mb: 2 }}>
//             {alert.severity === 'success' && (
//               <CheckIcon sx={{
//                 fontSize: 48,
//                 color: '#2e7d32',
//                 p: 1,
//                 borderRadius: '50%',
//                 backgroundColor: 'rgba(46, 125, 50, 0.1)'
//               }} />
//             )}
//             {alert.severity === 'error' && (
//               <Box component="span" sx={{
//                 fontSize: 48,
//                 color: '#d32f2f',
//                 p: 1,
//                 borderRadius: '50%',
//                 backgroundColor: 'rgba(211, 47, 47, 0.1)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}>
//                 ✕
//               </Box>
//             )}
//           </Box>

//           <DialogContentText sx={{
//             fontFamily: "Outfit, sans-serif",
//             fontSize: "18px",
//             textAlign: "center",
//             color: alert.severity === 'error' ? '#d32f2f' : '#2e7d32',
//             margin: 0,
//             fontWeight: 500
//           }}>
//             {alert.message}
//           </DialogContentText>
//         </DialogContent>
//       </Dialog>
//     </PostAccess>
//   );
// };

// export default PriceDetails;



import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { selectUser, addProperty, incrementPropertyCount } from '../Commonlibs/userSlice';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  TextField,
  InputAdornment,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogTitle,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { Check as CheckIcon, Login as LoginIcon } from "@mui/icons-material";
import Loader from '../Loader/Loader';
import PostAccess from './PostAccess';

// ✅ HELPER FUNCTIONS FOR OPTION 1
const appendIfValid = (formData, key, value) => {
  if (value !== null && value !== undefined && value !== '') {
    formData.append(key, value);
  } else {
    formData.append(key, '');
  }
};

const appendFieldWithUnit = (formData, fieldName, value, unit) => {
  if (value && value !== '' && value !== null && value !== undefined) {
    formData.append(fieldName, value);
    formData.append(`${fieldName}_units`, unit || '');
  } else {
    formData.append(fieldName, '');
    formData.append(`${fieldName}_units`, '');
  }
};

const PriceDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  // State variables
  const [askingPrice, setAskingPrice] = useState(() => localStorage.getItem('price_askingPrice') || '');
  const [askingPriceError, setAskingPriceError] = useState('');
  const [currency, setCurrency] = useState(() => localStorage.getItem('price_currency') || '₹');
  const [constructionStatus, setConstructionStatus] = useState(() => localStorage.getItem('price_constructionStatus') || 'ready to move');
  const [negotiable, setNegotiable] = useState(() => localStorage.getItem('price_negotiable') === 'false' ? false : true);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });
  
  const [loginDialog, setLoginDialog] = useState({ open: false });

  const { propertyType, category, ...otherProps } = location.state || {};

  // Clear form data
  const clearAllFormData = () => {
    setAskingPrice('');
    setCurrency('INR');
    setConstructionStatus('ready to move');
    setNegotiable(true);
    localStorage.removeItem('price_askingPrice');
    localStorage.removeItem('price_currency');
    localStorage.removeItem('price_constructionStatus');
    localStorage.removeItem('price_negotiable');
    localStorage.removeItem('propertyDetailsFormState');
    localStorage.removeItem('propertyType');
    localStorage.removeItem('category');
    localStorage.removeItem('propertyLocation');
    localStorage.removeItem('amenities_society');
    localStorage.removeItem('amenities_furnishing');
    localStorage.removeItem('amenities_other');
    localStorage.removeItem('propertyImagePreviews');
    setAskingPriceError('');
  };

  const formatIndianNumber = (num) => {
    if (!num) return '';
    const numStr = num.toString();
    const lastThree = numStr.substring(numStr.length - 3);
    const otherNumbers = numStr.substring(0, numStr.length - 3);
    if (otherNumbers !== '') {
      return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
    }
    return lastThree;
  };

  const convertToWords = (num) => {
    if (!num || num === '0') return '';
    const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const numToWords = (n) => {
      if (n < 10) return ones[n];
      if (n < 20) return teens[n - 10];
      if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + ones[n % 10] : '');
      return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + numToWords(n % 100) : '');
    };

    const crore = Math.floor(num / 10000000);
    const lakh = Math.floor((num % 10000000) / 100000);
    const thousand = Math.floor((num % 100000) / 1000);
    const hundred = num % 1000;

    let result = '';
    if (crore > 0) result += numToWords(crore) + ' Crore ';
    if (lakh > 0) result += numToWords(lakh) + ' Lakh ';
    if (thousand > 0) result += numToWords(thousand) + ' Thousand ';
    if (hundred > 0) result += numToWords(hundred);

    return result.trim();
  };

  const handleBack = () => {
    const assetType = location.state?.asset_type || '';
    const selectedType = location.state?.selectedType || '';
    const isPlot = assetType === 'plot' || selectedType === 'plot';
    const isAgricultureLand = assetType?.toLowerCase() === 'agriculture land' || selectedType === 'agriculture-land';
    const isCommercial = propertyType === 'Commercial';
    const isFarmhouse = assetType?.toLowerCase() === 'farm house' || selectedType === 'farm-house';

    const shouldShowAmenities = (!isCommercial || isFarmhouse) && !isPlot && !isAgricultureLand;

    if (shouldShowAmenities) {
      navigate('/amenities', {
        state: {
          propertyType: propertyType || location.state?.propertyType,
          category: category || location.state?.category,
          location: location.state?.location || '',
          asset_type: location.state?.asset_type || '',
          selectedType: location.state?.selectedType || '',
          ...location.state
        }
      });
    } else {
      navigate('/property-details', {
        state: {
          propertyType: propertyType || location.state?.propertyType,
          category: category || location.state?.category,
          location: location.state?.location || '',
          asset_type: location.state?.asset_type || '',
          selectedType: location.state?.selectedType || '',
          ...location.state
        }
      });
    }
  };

  useEffect(() => {
    localStorage.setItem('price_askingPrice', askingPrice);
    localStorage.setItem('price_currency', currency);
    localStorage.setItem('price_constructionStatus', constructionStatus);
    localStorage.setItem('price_negotiable', negotiable.toString());
  }, [askingPrice, currency, constructionStatus, negotiable]);

  const validateAskingPrice = (value) => {
    if (!value || value.trim() === '') {
      setAskingPriceError('Property cost is required');
      return false;
    }
    const priceRegex = /^[1-9]\d*$/;
    if (!priceRegex.test(value)) {
      setAskingPriceError('Please enter a valid whole number amount (e.g., 5000000)');
      return false;
    }
    const amount = parseInt(value, 10);
    if (amount < 100000) {
      setAskingPriceError('Property cost must be at least 1 lakh');
      return false;
    }
    if (amount > 10000000000) {
      setAskingPriceError('Property cost cannot exceed 1000 crores');
      return false;
    }
    setAskingPriceError('');
    return true;
  };

  const handleAskingPriceChange = (e) => {
    const value = e.target.value;
    if (value === '' || /^[0-9]*$/.test(value)) {
      setAskingPrice(value);
      validateAskingPrice(value);
    }
  };

  const handleUploadProperty = async () => {
    const isPriceValid = validateAskingPrice(askingPrice);

    if (!isPriceValid) {
      setAlert({
        open: true,
        message: 'Please fix the errors before submitting',
        severity: 'error'
      });
      return;
    }

    const userId = user?.id;
    if (!userId) {
      setLoginDialog({ open: true });
      return;
    }

    await performPropertyUpload();
  };

  const handleLoginRedirect = () => {
    setLoginDialog({ open: false });
    navigate('/login', { 
      state: { 
        returnTo: location.pathname,
        preserveData: true,
        ...location.state
      } 
    });
  };

  const performPropertyUpload = async () => {
    setLoading(true);

    try {
      if (!askingPrice || !currency || !constructionStatus) {
        setAlert({
          open: true,
          message: 'Please fill all required fields',
          severity: 'error'
        });
        setLoading(false);
        return;
      }

      const userId = user?.id;
      if (!userId) {
        setLoading(false);
        return;
      }

      const assetType = location.state?.asset_type || '';
      const selectedType = location.state?.selectedType || '';
      const assetTypeLower = assetType.toLowerCase();
      const selectedTypeLower = selectedType.toLowerCase();
      
      const isPlot = assetTypeLower === 'plot' || selectedTypeLower === 'plot';
      const isAgricultureLand = assetTypeLower === 'agriculture land' || selectedTypeLower === 'agriculture-land';
      const isCommercial = propertyType === 'Commercial';
      const isFarmhouse = assetTypeLower === 'farm house' || assetTypeLower === 'farmhouse' || selectedTypeLower === 'farm-house';
      const isApartment = assetTypeLower === 'apartment' || selectedTypeLower === 'apartment';
      const isIndependentHouse = assetTypeLower === 'independent house' || selectedTypeLower === 'independent-house';
      const isPentHouse = assetTypeLower === 'pent house' || assetTypeLower === 'penthouse' || selectedTypeLower === 'pent-house';
      const isStudio = assetTypeLower === 'studio' || selectedTypeLower === 'studio';
      const isVilla = assetTypeLower === 'villa' || selectedTypeLower === 'villa';
      const isOffice = assetTypeLower === 'office' || selectedTypeLower === 'office';
      const isShowroom = assetTypeLower === 'showroom' || selectedTypeLower === 'showroom';
      const isRetailShop = assetTypeLower === 'retail shop' || selectedTypeLower === 'retail-shop';
      const isWarehouse = assetTypeLower === 'warehouse' || assetTypeLower === 'ware house' || selectedTypeLower === 'warehouse';

      const formData = new FormData();
      
      // ✅ Basic required fields (always mandatory)
      formData.append('seller_id', userId.toString());
      formData.append('property_type', isCommercial ? 'commercial' : 'residential');
      formData.append('category', 'sale');
      appendIfValid(formData, 'location', location.state?.location);
      appendIfValid(formData, 'asset_type', assetType);
      appendIfValid(formData, 'property_name', location.state?.buildingName || location.state?.property_name);
      appendIfValid(formData, 'area_name', location.state?.areaName || location.state?.area_name);
      appendIfValid(formData, 'full_address', location.state?.completeAddress || location.state?.full_address);

      // ✅ Price and construction details
      formData.append('asking_price', askingPrice);
      formData.append('negotiable', negotiable.toString());
      formData.append('currency', currency);
      formData.append('construction_status', constructionStatus);

      // ✅ Rental fields - empty for sale
      formData.append('monthly_rent', '');
      formData.append('available_from', '');
      formData.append('security_deposit', '');

      // ✅ PROPERTY TYPE SPECIFIC FIELDS USING HELPER FUNCTIONS
      if (isApartment) {
        appendFieldWithUnit(formData, 'carpet_area', location.state?.carpet_area, location.state?.carpet_area_units || location.state?.carpetAreaUnits);
        appendFieldWithUnit(formData, 'built_up_area', location.state?.built_up_area || location.state?.builtUpArea, location.state?.built_up_area_units || location.state?.builtUpAreaUnits);
        appendFieldWithUnit(formData, 'uds', location.state?.uds, location.state?.uds_units || location.state?.udsUnits);
        appendFieldWithUnit(formData, 'property_size', '', '');
        appendIfValid(formData, 'zone_type', '');
        appendFieldWithUnit(formData, 'length', '', '');
        appendFieldWithUnit(formData, 'width', '', '');
      } 
      else if (isIndependentHouse) {
        appendFieldWithUnit(formData, 'built_up_area', location.state?.built_up_area || location.state?.builtUpArea, location.state?.built_up_area_units || location.state?.builtUpAreaUnits);
        appendFieldWithUnit(formData, 'property_size', location.state?.propertySize || location.state?.property_size, location.state?.property_size_units || location.state?.selectedUnit);
        appendFieldWithUnit(formData, 'uds', location.state?.uds, location.state?.uds_units || location.state?.udsUnits);
        appendFieldWithUnit(formData, 'carpet_area', '', '');
        appendIfValid(formData, 'zone_type', '');
        appendFieldWithUnit(formData, 'length', '', '');
        appendFieldWithUnit(formData, 'width', '', '');
      } 
      else if (isPentHouse) {
        appendFieldWithUnit(formData, 'carpet_area', location.state?.carpet_area, location.state?.carpet_area_units || location.state?.carpetAreaUnits);
        appendFieldWithUnit(formData, 'built_up_area', location.state?.built_up_area || location.state?.builtUpArea, location.state?.built_up_area_units || location.state?.builtUpAreaUnits);
        appendFieldWithUnit(formData, 'uds', location.state?.uds, location.state?.uds_units || location.state?.udsUnits);
        appendFieldWithUnit(formData, 'property_size', '', '');
        appendIfValid(formData, 'zone_type', '');
        appendFieldWithUnit(formData, 'length', '', '');
        appendFieldWithUnit(formData, 'width', '', '');
      } 
      else if (isStudio) {
        appendFieldWithUnit(formData, 'carpet_area', location.state?.carpet_area, location.state?.carpet_area_units || location.state?.carpetAreaUnits);
        appendFieldWithUnit(formData, 'built_up_area', location.state?.built_up_area || location.state?.builtUpArea, location.state?.built_up_area_units || location.state?.builtUpAreaUnits);
        appendFieldWithUnit(formData, 'uds', location.state?.uds, location.state?.uds_units || location.state?.udsUnits);
        appendFieldWithUnit(formData, 'property_size', '', '');
        appendIfValid(formData, 'zone_type', '');
        appendFieldWithUnit(formData, 'length', '', '');
        appendFieldWithUnit(formData, 'width', '', '');
      } 
      else if (isVilla) {
        appendFieldWithUnit(formData, 'built_up_area', location.state?.built_up_area || location.state?.builtUpArea, location.state?.built_up_area_units || location.state?.builtUpAreaUnits);
        appendFieldWithUnit(formData, 'property_size', location.state?.propertySize || location.state?.property_size, location.state?.property_size_units || location.state?.selectedUnit);
        appendFieldWithUnit(formData, 'carpet_area', '', '');
        appendFieldWithUnit(formData, 'uds', '', '');
        appendIfValid(formData, 'zone_type', '');
        appendFieldWithUnit(formData, 'length', '', '');
        appendFieldWithUnit(formData, 'width', '', '');
      } 
      else if (isPlot || isAgricultureLand) {
        appendFieldWithUnit(formData, 'property_size', location.state?.propertySize || location.state?.property_size, location.state?.property_size_units || location.state?.selectedUnit);
        appendIfValid(formData, 'zone_type', location.state?.zone_type || location.state?.zoneType);
        appendIfValid(formData, 'ownership', location.state?.ownership || location.state?.selectedOwnership);
        appendFieldWithUnit(formData, 'carpet_area', '', '');
        appendFieldWithUnit(formData, 'built_up_area', '', '');
        appendFieldWithUnit(formData, 'uds', '', '');
        
        if (isAgricultureLand) {
          appendFieldWithUnit(formData, 'length', '', '');
          appendFieldWithUnit(formData, 'width', '', '');
        } else {
          appendFieldWithUnit(formData, 'length', location.state?.length || location.state?.propertyLength, location.state?.length_units || location.state?.lengthUnit);
          appendFieldWithUnit(formData, 'width', location.state?.width || location.state?.propertyWidth, location.state?.width_units || location.state?.widthUnit);
        }
      } 
      else if (isFarmhouse) {
        appendFieldWithUnit(formData, 'built_up_area', location.state?.built_up_area || location.state?.builtUpArea, location.state?.built_up_area_units || location.state?.builtUpAreaUnits);
        appendFieldWithUnit(formData, 'property_size', location.state?.propertySize || location.state?.property_size, location.state?.property_size_units || location.state?.selectedUnit);
        appendFieldWithUnit(formData, 'carpet_area', location.state?.carpet_area, location.state?.carpet_area_units || location.state?.carpetAreaUnits);
        appendFieldWithUnit(formData, 'length', location.state?.length || location.state?.propertyLength, location.state?.length_units || location.state?.lengthUnit);
        appendFieldWithUnit(formData, 'width', location.state?.width || location.state?.propertyWidth, location.state?.width_units || location.state?.widthUnit);
        appendFieldWithUnit(formData, 'uds', '', '');
        appendIfValid(formData, 'zone_type', '');
      } 
      else if (isCommercial && isOffice) {
        appendFieldWithUnit(formData, 'property_size', location.state?.propertySize || location.state?.property_size, location.state?.property_size_units || location.state?.selectedUnit);
        appendFieldWithUnit(formData, 'built_up_area', location.state?.built_up_area || location.state?.builtUpArea, location.state?.built_up_area_units || location.state?.builtUpAreaUnits);
        appendIfValid(formData, 'zone_type', location.state?.zone_type || location.state?.zoneType);
        appendFieldWithUnit(formData, 'carpet_area', '', '');
        appendFieldWithUnit(formData, 'uds', '', '');
        appendFieldWithUnit(formData, 'length', '', '');
        appendFieldWithUnit(formData, 'width', '', '');
      } 
      else if (isCommercial && (isShowroom || isRetailShop)) {
        appendFieldWithUnit(formData, 'property_size', location.state?.propertySize || location.state?.property_size, location.state?.property_size_units || location.state?.selectedUnit);
        appendFieldWithUnit(formData, 'built_up_area', location.state?.built_up_area || location.state?.builtUpArea, location.state?.built_up_area_units || location.state?.builtUpAreaUnits);
        appendFieldWithUnit(formData, 'carpet_area', location.state?.carpet_area, location.state?.carpet_area_units || location.state?.carpetAreaUnits);
        appendIfValid(formData, 'zone_type', '');
        appendFieldWithUnit(formData, 'uds', '', '');
        appendFieldWithUnit(formData, 'length', '', '');
        appendFieldWithUnit(formData, 'width', '', '');
      } 
      else if (isCommercial && isWarehouse) {
        appendFieldWithUnit(formData, 'property_size', location.state?.propertySize || location.state?.property_size, location.state?.property_size_units || location.state?.selectedUnit);
        appendIfValid(formData, 'zone_type', location.state?.zone_type || location.state?.zoneType);
        appendFieldWithUnit(formData, 'built_up_area', location.state?.built_up_area || location.state?.builtUpArea, location.state?.built_up_area_units || location.state?.builtUpAreaUnits);
        appendFieldWithUnit(formData, 'carpet_area', location.state?.carpet_area, location.state?.carpet_area_units || location.state?.carpetAreaUnits);
        appendFieldWithUnit(formData, 'uds', '', '');
        appendFieldWithUnit(formData, 'length', '', '');
        appendFieldWithUnit(formData, 'width', '', '');
      } 
      else if (isCommercial && isPlot) {
        appendFieldWithUnit(formData, 'property_size', location.state?.propertySize || location.state?.property_size, location.state?.property_size_units || location.state?.selectedUnit);
        appendIfValid(formData, 'zone_type', location.state?.zone_type || location.state?.zoneType);
        appendIfValid(formData, 'ownership', location.state?.ownership || location.state?.selectedOwnership);
        appendFieldWithUnit(formData, 'length', location.state?.length || location.state?.propertyLength, location.state?.length_units || location.state?.lengthUnit);
        appendFieldWithUnit(formData, 'width', location.state?.width || location.state?.propertyWidth, location.state?.width_units || location.state?.widthUnit);
        appendFieldWithUnit(formData, 'built_up_area', '', '');
        appendFieldWithUnit(formData, 'carpet_area', '', '');
        appendFieldWithUnit(formData, 'uds', '', '');
      }
      else {
        // Default fallback
        appendFieldWithUnit(formData, 'property_size', location.state?.propertySize || location.state?.property_size, location.state?.property_size_units || location.state?.selectedUnit);
        appendFieldWithUnit(formData, 'built_up_area', location.state?.built_up_area || location.state?.builtUpArea, location.state?.built_up_area_units || location.state?.builtUpAreaUnits);
        appendFieldWithUnit(formData, 'carpet_area', location.state?.carpet_area, location.state?.carpet_area_units || location.state?.carpetAreaUnits);
        appendIfValid(formData, 'zone_type', location.state?.zone_type || location.state?.zoneType);
        appendFieldWithUnit(formData, 'uds', location.state?.uds, location.state?.uds_units || location.state?.udsUnits);
        appendFieldWithUnit(formData, 'length', location.state?.length || location.state?.propertyLength, location.state?.length_units || location.state?.lengthUnit);
        appendFieldWithUnit(formData, 'width', location.state?.width || location.state?.propertyWidth, location.state?.width_units || location.state?.widthUnit);
      }

      // ✅ Other fields using helper functions
      const youtubeLink = location.state?.socialMediaLink?.trim() || location.state?.youtube_link?.trim() || '';
      appendIfValid(formData, 'youtube_link', youtubeLink);
      appendIfValid(formData, 'description', location.state?.propertyDescription || location.state?.description);
      appendIfValid(formData, 'content', location.state?.content);
      appendIfValid(formData, 'landmark', location.state?.landmark);
      appendIfValid(formData, 'age_of_property', location.state?.age_of_property || location.state?.propertyAge);

      // ✅ BHK, furnishing, floors based on property type
      if (isPlot || isAgricultureLand) {
        appendIfValid(formData, 'locality', '');
        appendIfValid(formData, 'bhk', '');
        appendIfValid(formData, 'furnish_type', '');
        appendIfValid(formData, 'total_floors', '');
        appendIfValid(formData, 'select_floor', '');
        appendIfValid(formData, 'society_aminities', '');
        appendIfValid(formData, 'furnish_facilities', '');
        appendIfValid(formData, 'other_facilities', '');
        appendIfValid(formData, 'facilities_distance', '');
      } else {
        appendIfValid(formData, 'locality', location.state?.locality);
        
        if (!isCommercial) {
          appendIfValid(formData, 'bhk', location.state?.bhk || location.state?.selectedBHK);
          appendIfValid(formData, 'furnish_type', location.state?.furnish_type || location.state?.selectedFurnish);
        } else {
          appendIfValid(formData, 'bhk', '');
          appendIfValid(formData, 'furnish_type', '');
        }

        appendIfValid(formData, 'total_floors', location.state?.totalFloors || location.state?.total_floors);
        appendIfValid(formData, 'select_floor', location.state?.selectedFloor || location.state?.select_floor);

        if (!isCommercial || isFarmhouse) {
          appendIfValid(formData, 'society_aminities', location.state?.society_aminities);
          appendIfValid(formData, 'furnish_facilities', location.state?.furnish_facilities);
          appendIfValid(formData, 'other_facilities', location.state?.other_facilities);
          appendIfValid(formData, 'facilities_distance', location.state?.facilities_distance);
        } else {
          appendIfValid(formData, 'society_aminities', '');
          appendIfValid(formData, 'furnish_facilities', '');
          appendIfValid(formData, 'other_facilities', '');
          appendIfValid(formData, 'facilities_distance', '');
        }
      }

      // ✅ Commercial specific fields
      if (isCommercial) {
        formData.append('commercial_catgory', 'sale');
        appendIfValid(formData, 'commercial_asset_type', assetType);
        appendIfValid(formData, 'hub', location.state?.hub || location.state?.selectedHub);
        appendIfValid(formData, 'ownership', location.state?.ownership || location.state?.selectedOwnership);
      } else {
        formData.append('commercial_catgory', '');
        formData.append('commercial_asset_type', '');
        formData.append('hub', '');
        if (!isPlot && !isAgricultureLand) {
          appendIfValid(formData, 'ownership', '');
        }
      }

      // ✅ Images
      if (location.state?.propertyImages && location.state.propertyImages.length > 0) {
        location.state.propertyImages.forEach((file) => {
          formData.append('property_images', file);
        });
      }

      // ✅ Videos
      if (location.state?.propertyVideos && location.state.propertyVideos.length > 0) {
        location.state.propertyVideos.forEach((file) => {
          formData.append('property_videos', file);
        });
      }

            console.log('📤 FormData being sent (Option 1):', {
        asset_type: assetType,
        carpet_area: formData.get('carpet_area'),
        built_up_area: formData.get('built_up_area'),
        uds: formData.get('uds'),
        property_size: formData.get('property_size'),
        zone_type: formData.get('zone_type'),
        length: formData.get('length'),
        width: formData.get('width'),
        hub: formData.get('hub'),
        ownership: formData.get('ownership')
      });

      const response = await fetch('https://propertydealstalk.com/api/property/addProperty', {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (data.status === 'SUCCESS') {
        clearAllFormData();

        if (data.result && data.result.id) {
          dispatch(addProperty(data.result.id));
          dispatch(incrementPropertyCount());
        }

        setAlert({
          open: true,
          message: 'Property added successfully!',
          severity: 'success'
        });

        setTimeout(() => {
          navigate('/sell-properties');
        }, 2000);
      } else {
        throw new Error(data.message || 'Failed to add property');
      }
    } catch (error) {
      console.error('Error adding property:', error);
      setAlert({
        open: true,
        message: error.message || 'Failed to add property. Please try again.',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (alert.open) {
      const timer = setTimeout(() => {
        setAlert({ ...alert, open: false });
      }, 9000);
      return () => clearTimeout(timer);
    }
  }, [alert.open]);

  return (
    <PostAccess
      currentStep={3}
      category={category}
      propertyType={propertyType}
      assetType={location.state?.asset_type || ''}
    >
      {loading && <Loader />}

      <Box
        sx={{
          flex: 1,
          maxWidth: { xs: '100%', md: '800px' },
          p: { xs: 2.5, sm: 3, md: 3.5 },
          backgroundColor: '#ffffff',
          borderRadius: 2,
          border: '1px solid #e0e0e0',
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontFamily: 'Outfit',
            fontWeight: 600,
            mb: 0.5,
            fontSize: { xs: '18px', md: '22px' },
          }}
        >
          Add Price Details
        </Typography>

        <Typography
          sx={{
            fontFamily: 'Outfit',
            fontSize: '13px',
            color: '#666',
            mb: 3,
          }}
        >
          Complete all required fields
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 4 }}>
            {/* Property Cost */}
            <Box sx={{ width: '215px' }}>
              <Typography
                component="label"
                sx={{
                  fontFamily: "Outfit, sans-serif",
                  fontWeight: 500,
                  color: "text.secondary",
                  fontSize: "16px",
                  display: "block",
                  mb: 1.5,
                }}
              >
                Property Cost <Box component="span" sx={{ color: "#ff0000" }}>*</Box>
              </Typography>
              <TextField
                placeholder="Enter amount"
                value={formatIndianNumber(askingPrice)}
                onChange={(e) => {
                  const value = e.target.value.replace(/,/g, '');
                  if (value === '' || /^[0-9]*$/.test(value)) {
                    setAskingPrice(value);
                    validateAskingPrice(value);
                  }
                }}
                error={!!askingPriceError}
                helperText={askingPriceError}
                InputProps={{
                  endAdornment: <InputAdornment position="end">₹</InputAdornment>,
                }}
                sx={{
                  width: "100%",
                  "& .MuiInputBase-root": {
                    height: "50px",
                    bgcolor: "background.paper",
                    borderRadius: "10px",
                    fontFamily: "Outfit, sans-serif",
                    fontSize: "15px",
                  },
                }}
              />
              {askingPrice && !askingPriceError && (
                <Typography
                  sx={{
                    fontFamily: "Outfit, sans-serif",
                    fontSize: "12px",
                    color: "#4f26ff",
                    mt: 0.5,
                    fontStyle: "italic",
                  }}
                >
                  {convertToWords(parseInt(askingPrice))}
                </Typography>
              )}
            </Box>

            {/* Construction Status */}
            <Box sx={{ width: '215px' }}>
              <Typography
                component="label"
                sx={{
                  fontFamily: "Outfit, sans-serif",
                  fontWeight: 500,
                  color: "text.secondary",
                  fontSize: "16px",
                  display: "block",
                  mb: 1.5,
                }}
              >
                Construction Status <Box component="span" sx={{ color: "#ff0004" }}>*</Box>
              </Typography>
              <FormControl fullWidth>
                <Select
                  value={constructionStatus}
                  onChange={(e) => setConstructionStatus(e.target.value)}
                  sx={{
                    height: "50px",
                    borderRadius: "10px",
                    fontFamily: "Outfit, sans-serif",
                    fontSize: "15px",
                    bgcolor: "white",
                  }}
                >
                  <MenuItem value="ready to move" sx={{ fontFamily: "Outfit, sans-serif" }}>
                    Ready to Move
                  </MenuItem>
                  <MenuItem value="under construction" sx={{ fontFamily: "Outfit, sans-serif" }}>
                    Under Construction
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* Price Negotiable */}
            <Box sx={{ width: '215px' }}>
              <Typography
                component="label"
                sx={{
                  fontFamily: "Outfit, sans-serif",
                  fontWeight: 500,
                  color: "text.secondary",
                  fontSize: "16px",
                  display: "block",
                  mb: 1.5,
                }}
              >
                Price Negotiable? <Box component="span" sx={{ color: "#ff0004" }}>*</Box>
              </Typography>
              <FormControl fullWidth>
                <Select
                  value={negotiable}
                  onChange={(e) => setNegotiable(e.target.value)}
                  sx={{
                    height: "50px",
                    borderRadius: "10px",
                    fontFamily: "Outfit, sans-serif",
                    fontSize: "15px",
                    bgcolor: "white",
                  }}
                >
                  <MenuItem value={true} sx={{ fontFamily: "Outfit, sans-serif" }}>
                    Yes
                  </MenuItem>
                  <MenuItem value={false} sx={{ fontFamily: "Outfit, sans-serif" }}>
                    No
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>
        </Box>

        {/* Action Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 6,
            gap: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleBack}
            sx={{
              px: 3,
              py: 1.2,
              borderRadius: 1.5,
              textTransform: "none",
              fontFamily: "Outfit",
              fontSize: "14px",
              color: "#666",
              borderColor: "#e0e0e0",
              minWidth: "100px",
            }}
          >
            Back
          </Button>

          <Button
            onClick={handleUploadProperty}
            disabled={loading || !!askingPriceError}
            sx={{
              px: 3,
              py: 1.2,
              borderRadius: 1.5,
              textTransform: "none",
              fontFamily: "Outfit",
              fontSize: "14px",
              backgroundColor: "#1976d2",
              color: "white",
              minWidth: "150px",
              '&:hover': {
                backgroundColor: "#1565c0",
              },
              '&:disabled': {
                bgcolor: '#b0b0b0',
                color: '#f5f5f5'
              }
            }}
          >
            {loading ? "Uploading..." : "Post Property"}
          </Button>
        </Box>
      </Box>

      {/* Login Required Dialog */}
      <Dialog
        open={loginDialog.open}
        onClose={() => setLoginDialog({ open: false })}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.12)',
            maxWidth: "420px",
            width: "100%",
            margin: '0 16px',
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{
          textAlign: 'center',
          pt: 4,
          pb: 2,
          fontFamily: 'Outfit',
          fontSize: '22px',
          fontWeight: 600,
          color: '#333'
        }}>
          Login Required
        </DialogTitle>
        <DialogContent sx={{
          padding: "0 32px 24px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}>
          <Box sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            backgroundColor: 'rgba(25, 118, 210, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2
          }}>
            <LoginIcon sx={{ fontSize: 32, color: '#1976d2' }} />
          </Box>
          <DialogContentText sx={{
            fontFamily: "Outfit",
            fontSize: "16px",
            textAlign: "center",
            color: '#666',
            margin: 0,
            lineHeight: 1.6
          }}>
            Please login to continue posting your property. Your progress will be saved.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{
          padding: '0 32px 32px',
          flexDirection: 'column',
          gap: 1.5
        }}>
          <Button
            onClick={handleLoginRedirect}
            variant="contained"
            fullWidth
            sx={{
              py: 1.5,
              borderRadius: 2,
              textTransform: "none",
              fontFamily: "Outfit",
              fontSize: "15px",
              fontWeight: 600,
              backgroundColor: "#1976d2",
              boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
              '&:hover': {
                backgroundColor: "#1565c0",
                boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)',
              }
            }}
          >
            Login Now
          </Button>
          <Button
            onClick={() => setLoginDialog({ open: false })}
            variant="text"
            fullWidth
            sx={{
              py: 1.2,
              borderRadius: 2,
              textTransform: "none",
              fontFamily: "Outfit",
              fontSize: "14px",
              color: "#666",
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
              }
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Alert Dialog */}
      <Dialog
        open={alert.open}
        onClose={() => setAlert({ ...alert, open: false })}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
            maxWidth: "400px",
            width: "100%",
            margin: '0 16px',
            overflow: 'hidden'
          }
        }}
      >
        <DialogContent sx={{
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#ffffff",
          minHeight: "180px",
        }}>
          <Box sx={{ mb: 2 }}>
            {alert.severity === 'success' && (
              <CheckIcon sx={{
                fontSize: 48,
                color: '#2e7d32',
                p: 1,
                borderRadius: '50%',
                backgroundColor: 'rgba(46, 125, 50, 0.1)'
              }} />
            )}
            {alert.severity === 'error' && (
              <Box component="span" sx={{
                fontSize: 48,
                color: '#d32f2f',
                p: 1,
                borderRadius: '50%',
                backgroundColor: 'rgba(211, 47, 47, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                ✕
              </Box>
            )}
          </Box>

          <DialogContentText sx={{
            fontFamily: "Outfit, sans-serif",
            fontSize: "18px",
            textAlign: "center",
            color: alert.severity === 'error' ? '#d32f2f' : '#2e7d32',
            margin: 0,
            fontWeight: 500
          }}>
            {alert.message}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </PostAccess>
  );
};

export default PriceDetails;

